import { render, staticRenderFns } from "./ClassSchedule.vue?vue&type=template&id=8e27da00&scoped=true&"
import script from "./ClassSchedule.vue?vue&type=script&lang=js&"
export * from "./ClassSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ClassSchedule.vue?vue&type=style&index=0&id=8e27da00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e27da00",
  null
  
)

export default component.exports